import React, { useState, useEffect, forwardRef } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Box,
  InputLabel,
  MenuItem,
  FormControl,
  Select,
  Button,
  Dialog,
  TextField,
  AppBar,
  Toolbar as MuiToolbar,
  IconButton,
  Typography,
  Slide,
  DialogActions,
  Paper,
  Checkbox,
  FormControlLabel,
  Radio,
  RadioGroup,
  FormLabel,
  DialogContent,
  DialogTitle,
  CircularProgress,
  Pagination,
  Stack,
  InputAdornment,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Unstable_Grid2";
import dayjs from "dayjs";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { setLoadingPanel } from "../../redux/features/loading";
import { useDispatch, useSelector } from "react-redux";
import CircularIndeterminateModal from "../../utils/Loading";
import { UsersSubscriptionsApi } from "apis/UsersSubscriptionsApi";
import { UsersApi } from "apis/UsersApi";
import { formatDate } from "utils";
import ExcelExport from "components/ExcelExport/ExcelExport";
import {
  EditButton,
  FormCard,
  TableCard,
  Toolbar,
  ActionButton,
  DataTable,
  DataRow,
  Cell,
  StatusBadge,
  PageTitle,
  filterInputSx,
  filterSelectSx,
  filterFormControlSx,
} from "utils/ui";
import { createSvgIcon } from "@mui/material";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const LastDayOfMonth = (y, m) => {
  return new Date(y, m, 0).getDate();
};

function Subscriptions() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.loadingReducer.isLoading);
  const [open, setOpen] = React.useState(false);
  const [openGenerateInvoice, setOpenGenerateInvoice] = React.useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [usersSubscriptions, setUsersSubscriptions] = useState([]);
  const [filteredUsersSubscriptions, setfilteredUserSubscriptions] = useState(
    []
  );
  const [formData, setFormData] = useState({
    id: "",
    name: "",
    email: "",
    mobile: "",
    isActive: true,
    price: "",
    startDate: "",
    endDate: "",
  });

  const date = new Date();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  const periodFrom = `${year}-${month > 9 ? month : "0" + month}-01`;
  const periodTo = `${year}-${month > 9 ? month : "0" + month}-${LastDayOfMonth(
    year,
    month
  )}`;
  let fileName = `UserSubscriptionData_${date.getDate()}${
    date.getMonth() + 1
  }${date.getFullYear()}_${date.getHours()}${date.getMinutes()}`;
  const [isEdit, setIsEdit] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState();
  const [mobileNo, setMobileNo] = useState("");
  const [totalElements, setTotalElements] = useState("");
  const startDateInput = dayjs(formData.startDate);
  const endDateInput = dayjs(formData.endDate);
  const [price, setPrice] = useState(null);
  const [invoiceNo, setInvoiceNo] = useState(null);
  const [subscription, setSubscription] = useState([]);
  const [editSubscription, setEditSubscription] = useState(null);
  const [isGenerating, setIsGenerating] = useState(false);
  const [invoice, setInvoice] = useState({
    id: null,
    invoiceNo: null,
  });

  const getSubscription = () => {
    UsersSubscriptionsApi.GetSubscription()
      .then((res) => {
        setSubscription(res.data.data);
      })
      .catch((err) => {
        toast(err?.response?.data?.message, {
          type: "error",
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
      });
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleCloseGenerateInvoice = () => {
    setOpenGenerateInvoice(false);
  };

  useEffect(() => {
    getSubscription();
    const filtered = usersSubscriptions.filter((subscription) =>
      subscription.user.mobile.includes(searchTerm)
    );
    setfilteredUserSubscriptions(filtered);
  }, [searchTerm, usersSubscriptions]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleGenerateInvoice = (row) => {
    setOpenGenerateInvoice(true);
    setInvoice({
      ...invoice,
      id: row.id,
      invoiceNo: row.id,
    });
  };

  const GenerateInvoice = () => {
    console.log("In", invoice);
    UsersSubscriptionsApi.Invoice({
      id: invoice.id,
      invoiceNo: invoice.invoiceNo,
    })
      .then((res) => {
        setIsGenerating(true);
        handleCloseGenerateInvoice();
        GetUserSubscriptions(currentPage - 1, 25);
        setIsGenerating(false);
        toast("Invoice Generated", {
          type: "success",
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
      })
      .catch((err) => {
        setIsGenerating(false);
        toast(err.response.status + " " + err?.response?.data?.message, {
          type: "error",
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
      });
  };

  const handleChangeDate = (name, value) => {
    let date = new Date(value);
    let mnth = ("0" + (date.getMonth() + 1)).slice(-2);
    let day = ("0" + date.getDate()).slice(-2);
    const selectedDate = [date.getFullYear(), mnth, day].join("-");

    setFormData({
      ...formData,
      [name]: selectedDate,
    });
  };

  const [filterPayload, setFilterPayload] = useState({
    isActive: true,
    startDate: "",
    endDate: "",
    sortBy: null,
    price: null,
    invoiceNo: null,
    direction: null,
    mobile: null,
  });
  const clearSearch = () => {
    setFilterPayload({
      isActive: null,
      startDate: "",
      endDate: "",
      sortBy: null,
      price: null,
      invoiceNo: null,
      direction: null,
      mobile: null,
    });
    setInvoiceNo("");
    setPrice("");
    setMobileNo("");
    GetUserSubscriptions(0, 25);
    setCurrentPage(1);
  };

  const [userSize, setUserSize] = useState(25);
  const [openExcelDialog, setOpenExcelDialog] = React.useState(false);
  const handleClickOpenExcelDialog = () => {
    setOpenExcelDialog(true);
  };
  const handleCloseExcelDialog = () => {
    setOpenExcelDialog(false);
  };
  const [excelData, setExcelData] = useState([]);

  const GetUserSubscriptions = (page, size) => {
    dispatch(setLoadingPanel(true));
    UsersSubscriptionsApi.GetUserSubscriptions({
      page: page,
      size: size,
      mobile: filterPayload.mobile,
      isActive: filterPayload.isActive,
      startDate: filterPayload.startDate,
      endDate: filterPayload.endDate,
      sortBy: filterPayload.sortBy,
      price: filterPayload.price,
      invoiceNo: filterPayload.invoiceNo,
      direction: filterPayload.direction,
    })
      .then((res) => {
        setUsersSubscriptions(res.data.data);
        setTotalElements(res.data.totalElements);
        setTotalPages(res.data.pages);
        setfilteredUserSubscriptions(usersSubscriptions);
        const excelDataArray = res.data.data.map((m) => ({
          name: m?.user?.name,
          mobile: m?.user?.mobile,
          email: m?.user?.email,
          invoiceNumber: m?.invoiceNo,
          price: m?.price,
          isActive: m?.isActive,
          startDate: m?.startDate,
          endDate: m?.endDate,
        }));
        setExcelData(excelDataArray);
        dispatch(setLoadingPanel(false));
      })
      .catch((err) => {
        dispatch(setLoadingPanel(false));
        if (err?.response?.data) {
          toast(err.response.status + " " + err?.response?.data?.message, {
            type: "error",
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
          });
        } else {
          toast(err?.response?.data?.message, {
            type: "error",
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
          });
        }
        toast(err?.response?.data?.message, {
          type: "error",
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
        if (err.response.status === 401) {
          localStorage.clear();
          navigate("/");
        }
      });
  };
  const EditUserSubscription = (row) => {
    setIsEdit(true);
    setFormData({
      id: row.id,
      name: row.user.name,
      email: row.user.email,
      mobile: row.user.mobile,
      isActive: row.isActive,
      price: row.price,
      startDate: row.startDate,
      endDate: row.endDate,
    });
    setOpen(true);
  };

  const EditSubscription = (row) => {
    setIsEdit(true);
    setFormData({
      id: row.id,
      name: row.user.name,
      email: row.user.email,
      mobile: row.user.mobile,
      isActive: row.isActive,
      price: row.price,
      startDate: row.startDate,
      endDate: row.endDate,
    });
    setOpen(true);
  };
  const edit = () => {
    UsersSubscriptionsApi.EditUserSubscription(formData.id, formData)
      .then((res) => {
        toast("Subscription Updated", {
          type: "success",
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
        setOpen(false);
        GetUserSubscriptions(0, 25);
      })
      .catch((err) => {
        if (err?.response?.data) {
          toast(err.response.status + " " + err?.response?.data?.message, {
            type: "error",
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
          });
        } else {
          toast(err?.response?.data?.message, {
            type: "error",
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
          });
        }
        if (err.response.status === 401) {
          localStorage.clear();
          navigate("/");
        }
      });
  };

  const handlePageChange = (event, page) => {
    setCurrentPage(page);

    GetUserSubscriptions(page - 1, 25);
    return currentPage;
  };

  useEffect(() => {
    GetUserSubscriptions(0, 25);
  }, [filterPayload]);

  useEffect(() => {
    GetUserSubscriptions(0, 25);
  }, []);

  return (
    <>
      <CircularIndeterminateModal open={isLoading && !usersSubscriptions.length} />
      
      <FormCard>
        <PageTitle
          title="Subscriptions Management"
          subtitle="Manage standard subscription packages and user-specific billing"
          actions={
            <CreateSubscription
              row={editSubscription}
              setRow={setEditSubscription}
              GetUserSubscriptions={GetUserSubscriptions}
            />
          }
        />

        <Toolbar>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 3, width: "100%" }}>
            <Box sx={{ display: "flex", flexWrap: "wrap", items: "center", gap: 3 }}>
              <Box sx={{ flex: 1, minWidth: { xs: "100%", sm: 280 } }}>
                <TextField
                  fullWidth
                  sx={filterInputSx}
                  label="Search by Mobile Number"
                  placeholder="Enter 10 digit mobile..."
                  value={mobileNo}
                  onChange={(e) => {
                    setMobileNo(e.target.value);
                    if (e.target.value?.length === 10) {
                      setFilterPayload({ ...filterPayload, mobile: e.target.value });
                    } else if (e.target.value?.length === 0) {
                      setFilterPayload({ ...filterPayload, mobile: null });
                    }
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon sx={{ color: "slate.400", fontSize: 20 }} />
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>

              <Box sx={{ display: "flex", items: "center", gap: 2, width: { xs: "100%", sm: "auto" } }}>
                <TextField
                  type="date"
                  label="From"
                  InputLabelProps={{ shrink: true }}
                  value={filterPayload.startDate || ""}
                  onChange={(e) => setFilterPayload({ ...filterPayload, startDate: e.target.value })}
                  sx={{ ...filterInputSx, flex: 1, minWidth: 130 }}
                />
                <TextField
                  type="date"
                  label="To"
                  InputLabelProps={{ shrink: true }}
                  value={filterPayload.endDate || ""}
                  onChange={(e) => setFilterPayload({ ...filterPayload, endDate: e.target.value })}
                  sx={{ ...filterInputSx, flex: 1, minWidth: 130 }}
                />
              </Box>

              <Box sx={{ display: "flex", items: "center", gap: 2, pl: { xs: 0, sm: 4 }, borderLeft: { xs: "none", sm: "1px solid var(--color-border)" }, width: { xs: "100%", sm: "auto" } }}>
                <FormControl component="fieldset">
                  <RadioGroup
                    row
                    value={filterPayload.isActive === null ? "all" : filterPayload.isActive.toString()}
                    onChange={(e) => {
                      const val = e.target.value;
                      setFilterPayload({ ...filterPayload, isActive: val === "all" ? null : val === "true" });
                    }}
                  >
                    <FormControlLabel value="all" control={<Radio size="small" />} label={<Typography variant="caption">All</Typography>} />
                    <FormControlLabel value="true" control={<Radio size="small" />} label={<Typography variant="caption">Active</Typography>} />
                    <FormControlLabel value="false" control={<Radio size="small" />} label={<Typography variant="caption">Inactive</Typography>} />
                  </RadioGroup>
                </FormControl>
              </Box>
            </Box>

            <Box sx={{ display: "flex", flexWrap: "wrap", items: "center", gap: 3, pt: 3, borderTop: "1px solid", borderColor: "slate.100" }}>
              <FormControl sx={{ ...filterFormControlSx, flex: { xs: 1, sm: "none" }, minWidth: 150 }}>
                <InputLabel>Sort By</InputLabel>
                <Select
                  value={filterPayload.sortBy || ""}
                  label="Sort By"
                  onChange={(e) => setFilterPayload({ ...filterPayload, sortBy: e.target.value })}
                  sx={filterSelectSx}
                >
                  <MenuItem value="">--Select--</MenuItem>
                  <MenuItem value="price">Price</MenuItem>
                  <MenuItem value="startDate">Start Date</MenuItem>
                  <MenuItem value="endDate">End Date</MenuItem>
                  <MenuItem value="isActive">Status</MenuItem>
                  <MenuItem value="invoiceNo">Invoice #</MenuItem>
                </Select>
              </FormControl>

              <FormControl sx={{ ...filterFormControlSx, flex: { xs: 1, sm: "none" }, minWidth: 140 }}>
                <InputLabel>Order</InputLabel>
                <Select
                  value={filterPayload.direction || ""}
                  label="Order"
                  onChange={(e) => setFilterPayload({ ...filterPayload, direction: e.target.value })}
                  sx={filterSelectSx}
                >
                  <MenuItem value="">--Select--</MenuItem>
                  <MenuItem value="ASC">Low to High</MenuItem>
                  <MenuItem value="DESC">High to Low</MenuItem>
                </Select>
              </FormControl>

              <TextField
                label="Min Price"
                type="number"
                value={price}
                onChange={(e) => {
                  setPrice(e.target.value);
                  setFilterPayload({ ...filterPayload, price: e.target.value });
                }}
                sx={{ ...filterInputSx, flex: { xs: 1, sm: "none" }, minWidth: 100 }}
              />

              <TextField
                label="Invoice #"
                value={invoiceNo}
                onChange={(e) => {
                  setInvoiceNo(e.target.value);
                  setFilterPayload({ ...filterPayload, invoiceNo: e.target.value });
                }}
                sx={{ ...filterInputSx, flex: { xs: 1, sm: "none" }, minWidth: 120 }}
              />

              <Box sx={{ flex: 1, display: { xs: "none", lg: "block" } }} />
              
              <Box sx={{ display: "flex", items: "center", gap: 2, width: { xs: "100%", sm: "auto" }, justifyContent: { xs: "space-between", sm: "flex-end" } }}>
                <AddUserSubscription subscription={subscription} />
                <ActionButton
                  variant="secondary"
                  onClick={clearSearch}
                  startIcon={<RestartAltIcon className="w-4 h-4" />}
                  fullWidth={{ xs: true, sm: false }}
                >
                  Reset
                </ActionButton>
              </Box>
            </Box>
          </Box>
        </Toolbar>
      </FormCard>

      <div className="space-y-6 mt-6">
        <TableCard>
          <div className="p-6 border-b border-slate-100 flex justify-between items-center">
            <div>
              <h3 className="text-lg font-semibold text-slate-800">Subscription Templates</h3>
              <p className="text-sm text-slate-500">Available subscription and service packages</p>
            </div>
          </div>
          <DataTable>
            <thead>
              <tr>
                <Cell variant="head">#</Cell>
                <Cell variant="head">Name</Cell>
                <Cell variant="head">Validity</Cell>
                <Cell variant="head">Price</Cell>
                <Cell variant="head">Disc. Price</Cell>
                <Cell variant="head">Logins</Cell>
                <Cell variant="head">Status</Cell>
                <Cell variant="head" align="right">Actions</Cell>
              </tr>
            </thead>
            <tbody>
              {subscription?.map((s, i) => (
                <DataRow key={s.id || i}>
                  <Cell variant="index">{i + 1}</Cell>
                  <Cell>
                    <span className="font-medium text-slate-700">{s.name}</span>
                  </Cell>
                  <Cell>{s.validity} Days</Cell>
                  <Cell>₹{s.price}</Cell>
                  <Cell>₹{s.discountedPrice}</Cell>
                  <Cell>{s.logins}</Cell>
                  <Cell>
                    <StatusBadge status={s.isActive ? "active" : "inactive"}>
                      {s.isActive ? "Active" : "Inactive"}
                    </StatusBadge>
                  </Cell>
                  <Cell align="right">
                    <EditButton onClick={() => setEditSubscription(s)} />
                  </Cell>
                </DataRow>
              ))}
            </tbody>
          </DataTable>
        </TableCard>

        <TableCard>
          <div className="p-6 border-b border-slate-100 flex flex-col sm:flex-row justify-between items-center gap-4">
            <div>
              <h3 className="text-lg font-semibold text-slate-800">User Subscriptions</h3>
              <p className="text-sm text-slate-500">Active billing and service records for individual users</p>
            </div>
            <div className="flex items-center gap-3 w-full sm:w-auto justify-between">
              <span className="text-sm font-medium text-slate-500">
                Total: <span className="text-indigo-600 font-bold">{totalElements}</span>
              </span>
              <ActionButton
                variant="secondary"
                size="small"
                onClick={handleClickOpenExcelDialog}
                fullWidth={{ xs: true, sm: false }}
                startIcon={
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                }
              >
                Export
              </ActionButton>
            </div>
          </div>
          <DataTable>
            <thead>
              <tr>
                <Cell variant="head">#</Cell>
                <Cell variant="head">User</Cell>
                <Cell variant="head">Invoice Number</Cell>
                <Cell variant="head">Status</Cell>
                <Cell variant="head">Price</Cell>
                <Cell variant="head">Period</Cell>
                <Cell variant="head" align="right">Actions</Cell>
              </tr>
            </thead>
            <tbody>
              {usersSubscriptions.map((u, i) => (
                <DataRow key={u.id || i}>
                  <Cell variant="index">{i + 1}</Cell>
                  <Cell>
                    <Box sx={{ lineHeigh: 1.2 }}>
                      <Typography variant="body2" sx={{ fontWeight: 600, color: "slate.700" }}>
                        {u.user?.name}
                      </Typography>
                      <Typography variant="caption" sx={{ color: "slate.500", display: "block" }}>
                        {u.user?.mobile}
                      </Typography>
                      <Typography variant="caption" sx={{ color: "slate.400", display: "block" }}>
                        {u.user?.email}
                      </Typography>
                    </Box>
                  </Cell>
                  <Cell>
                    <Typography variant="body2" sx={{ fontFamily: "monospace", color: "slate.600" }}>
                      {u.invoiceNo || "—"}
                    </Typography>
                  </Cell>
                  <Cell>
                    <StatusBadge status={u.isActive ? "active" : "inactive"}>
                      {u.isActive ? "Active" : "Inactive"}
                    </StatusBadge>
                  </Cell>
                  <Cell>
                    <Typography variant="body2" sx={{ fontWeight: 600, color: "indigo.600" }}>
                      ₹{u.price}
                    </Typography>
                  </Cell>
                  <Cell>
                    <Box>
                      <Typography variant="caption" sx={{ display: "block", color: "emerald.600", fontWeight: 500 }}>
                        S: {formatDate(u.startDate)}
                      </Typography>
                      <Typography variant="caption" sx={{ display: "block", color: "rose.600", fontWeight: 500 }}>
                        E: {formatDate(u.endDate)}
                      </Typography>
                    </Box>
                  </Cell>
                  <Cell align="right">
                    <div className="flex justify-end gap-1">
                      {u.invoiceUrl ? (
                        <ActionButton
                          size="small"
                          variant="secondary"
                          onClick={() => window.open(u.invoiceUrl, "_blank")}
                        >
                          Invoice
                        </ActionButton>
                      ) : (
                        <ActionButton
                          size="small"
                          variant="secondary"
                          onClick={() => handleGenerateInvoice(u)}
                        >
                          Generate
                        </ActionButton>
                      )}
                      <EditButton onClick={() => EditUserSubscription(u)} />
                    </div>
                  </Cell>
                </DataRow>
              ))}
            </tbody>
          </DataTable>
          <div className="p-4 border-t border-slate-100 bg-slate-50/50 flex justify-center w-full">
            <Pagination
              count={totalPages}
              page={currentPage}
              color="primary"
              onChange={handlePageChange}
              size="medium"
              sx={{ 
                "& .MuiPagination-ul": { justifyContent: "center", width: "100%" }
              }}
            />
          </div>
        </TableCard>
      </div>

      {/* Export Dialog */}
      <Dialog
        open={openExcelDialog}
        onClose={handleCloseExcelDialog}
        PaperProps={{
          sx: { borderRadius: 3, width: "100%", maxWidth: 400 }
        }}
      >
        <DialogTitle sx={{ pb: 1 }}>Export Records</DialogTitle>
        <DialogContent sx={{ p: { xs: 2.5, sm: 4 } }}>
          <Typography variant="body2" sx={{ color: "slate.500", mb: 3 }}>
            Select the number of latest records you want to include in the export.
          </Typography>
          <Box className="flex items-center gap-4">
            <Typography variant="body2">Include last</Typography>
            <TextField
              size="small"
              type="number"
              value={userSize}
              onChange={(e) => {
                GetUserSubscriptions(0, e.target.value);
                setUserSize(e.target.value);
              }}
              sx={{ width: 80 }}
            />
            <Typography variant="body2">records</Typography>
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 3, pt: 0 }}>
          <Button onClick={handleCloseExcelDialog} sx={{ color: "slate.400" }}>Cancel</Button>
          <ExcelExport excelData={excelData} fileName={fileName} size="medium" />
        </DialogActions>
      </Dialog>

      {/* Generate Invoice Dialog */}
      <Dialog
        open={openGenerateInvoice}
        onClose={handleCloseGenerateInvoice}
        PaperProps={{
          sx: { borderRadius: 3, width: "100%", maxWidth: 400 }
        }}
      >
        <DialogTitle sx={{ pb: 1 }}>Generate Invoice</DialogTitle>
        <DialogContent sx={{ p: { xs: 2.5, sm: 4 } }}>
          <Typography variant="body2" sx={{ color: "slate.500", mb: 3 }}>
            Please enter the billing reference number to generate the invoice.
          </Typography>
          <TextField
            fullWidth
            label="Invoice Number"
            placeholder="e.g. INV-2024-001"
            value={invoice.invoiceNo}
            onChange={(e) => setInvoice({ ...invoice, invoiceNo: e.target.value })}
          />
        </DialogContent>
        <DialogActions sx={{ p: 3, pt: 0 }}>
          <Button onClick={handleCloseGenerateInvoice} sx={{ color: "slate.400" }}>Cancel</Button>
          <ActionButton
            onClick={GenerateInvoice}
            disabled={isGenerating || !invoice.invoiceNo}
          >
            {isGenerating ? "Processing..." : "Generate Invoice"}
          </ActionButton>
        </DialogActions>
      </Dialog>

      {/* Edit User Subscription Dialog (Legacy Edit) */}
      <Dialog 
        open={open} 
        onClose={handleClose}
        PaperProps={{ sx: { borderRadius: 3 } }}
      >
        <DialogTitle>Edit Listing Details</DialogTitle>
        <DialogContent sx={{ p: { xs: 2.5, sm: 4 } }}>
          <Box sx={{ pt: 1, display: "flex", flexDirection: "column", gap: 3 }}>
            <Box className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <TextField label="Name" name="name" value={formData.name} onChange={handleChange} fullWidth disabled />
              <TextField label="Mobile" name="mobile" value={formData.mobile} onChange={handleChange} fullWidth disabled />
            </Box>
            <Box className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <TextField label="Start Date" type="date" name="startDate" value={formData.startDate} onChange={(e) => handleChangeDate("startDate", e.target.value)} InputLabelProps={{ shrink: true }} fullWidth />
              <TextField label="End Date" type="date" name="endDate" value={formData.endDate} onChange={(e) => handleChangeDate("endDate", e.target.value)} InputLabelProps={{ shrink: true }} fullWidth />
            </Box>
            <TextField label="Price" type="number" name="price" value={formData.price} onChange={handleChange} fullWidth />
            <FormControl>
              <FormLabel sx={{ fontWeight: 600, mb: 1 }}>Status</FormLabel>
              <RadioGroup row name="isActive" value={formData.isActive} onChange={(e) => setFormData({ ...formData, isActive: e.target.value === "true" })}>
                <FormControlLabel value={true} control={<Radio />} label="Active" />
                <FormControlLabel value={false} control={<Radio />} label="Inactive" />
              </RadioGroup>
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 3, pt: 1 }}>
          <Button onClick={handleClose}>Cancel</Button>
          <ActionButton onClick={edit}>Save Changes</ActionButton>
        </DialogActions>
      </Dialog>
    </>
  );
}

const CreateSubscription = ({ GetUserSubscriptions, row, setRow }) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [addSubscriptionData, setAddSubscriptionData] = useState({
    name: null,
    validity: null,
    price: null,
    discountedPrice: null,
    message: null,
    displayOnApp: null,
    isActive: null,
    isTrial: null,
    logins: null,
    isDeleted: null,
  });

  useEffect(() => {
    if (row) {
      setAddSubscriptionData({
        name: row.name,
        validity: row.validity,
        price: row.price,
        discountedPrice: row.discountedPrice,
        message: row.message,
        displayOnApp: row.displayOnApp,
        isActive: row.isActive,
        isTrial: row.isTrial,
        isDeleted: row.isDeleted,
        logins: row.logins,
      });
    }
  }, [row]);

  const createUpdateSubscription = () => {
    const apiCall = row 
      ? UsersSubscriptionsApi.UpdateSubscription(row.id, addSubscriptionData)
      : UsersSubscriptionsApi.CreateSubscription(addSubscriptionData);

    apiCall
      .then((res) => {
        toast(`Subscription ${row ? "Updated" : "Created"}`, {
          type: "success",
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
        setOpen(false);
        setRow(null);
        GetUserSubscriptions(0, 25);
      })
      .catch((err) => {
        const msg = err?.response?.data?.message || err?.message || "An error occurred";
        toast(msg, { type: "error", position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
        if (err.response?.status === 401) {
          localStorage.clear();
          navigate("/");
        }
      });
  };

  const PlusIconAlt = createSvgIcon(
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
    </svg>,
    "PlusAlt"
  );

  const handleClose = () => {
    setRow(null);
    setOpen(false);
  };

  return (
    <>
      <ActionButton
        variant="primary"
        onClick={() => {
          setOpen(true);
          setAddSubscriptionData({
            name: "", validity: "", price: "", discountedPrice: "",
            message: "", displayOnApp: true, isActive: true,
            isTrial: false, isDeleted: false, logins: 1
          });
        }}
        startIcon={<PlusIconAlt className="w-4 h-4" />}
      >
        New Template
      </ActionButton>

      <Dialog
        fullScreen
        open={!!row || open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: "relative", bgcolor: "white", color: "slate.900", boxShadow: "0 1px 2px rgba(0,0,0,0.05)" }}>
          <MuiToolbar>
            <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1, fontWeight: 700 }} variant="h6">
              {row ? `Edit Template: ${row.name}` : "Create Subscription Template"}
            </Typography>
            <ActionButton onClick={createUpdateSubscription}>
              {row ? "Save Changes" : "Create Template"}
            </ActionButton>
          </MuiToolbar>
        </AppBar>
        
        <DialogContent sx={{ bgcolor: "slate.50/50", p: { xs: 2, md: 4 } }}>
          <div className="max-w-5xl mx-auto space-y-6">
            <Paper sx={{ p: 4, borderRadius: 3 }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 3, color: "slate.800" }}>
                Basic Information
              </Typography>
              <Grid container spacing={4}>
                <Grid xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Package Name"
                    placeholder="e.g. Premium Annual Plan"
                    value={addSubscriptionData.name}
                    onChange={(e) => setAddSubscriptionData({ ...addSubscriptionData, name: e.target.value })}
                  />
                </Grid>
                <Grid xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Number of Logins"
                    type="number"
                    value={addSubscriptionData.logins}
                    onChange={(e) => setAddSubscriptionData({ ...addSubscriptionData, logins: e.target.value })}
                  />
                </Grid>
                <Grid xs={12}>
                  <TextField
                    fullWidth
                    multiline
                    rows={2}
                    label="Notification Message"
                    placeholder="Message to show users about this plan..."
                    value={addSubscriptionData.message}
                    onChange={(e) => setAddSubscriptionData({ ...addSubscriptionData, message: e.target.value })}
                  />
                </Grid>
              </Grid>
            </Paper>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <Paper sx={{ p: 4, borderRadius: 3 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 3, color: "slate.800" }}>
                  Pricing & Validity
                </Typography>
                <Grid container spacing={3}>
                  <Grid xs={12}>
                    <TextField
                      fullWidth
                      label="Validity (Days)"
                      type="number"
                      value={addSubscriptionData.validity}
                      onChange={(e) => setAddSubscriptionData({ ...addSubscriptionData, validity: e.target.value })}
                    />
                  </Grid>
                  <Grid xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="Standard Price"
                      type="number"
                      InputProps={{ startAdornment: <InputAdornment position="start">₹</InputAdornment> }}
                      value={addSubscriptionData.price}
                      onChange={(e) => setAddSubscriptionData({ ...addSubscriptionData, price: e.target.value })}
                    />
                  </Grid>
                  <Grid xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="Discounted Price"
                      type="number"
                      InputProps={{ startAdornment: <InputAdornment position="start">₹</InputAdornment> }}
                      value={addSubscriptionData.discountedPrice}
                      onChange={(e) => setAddSubscriptionData({ ...addSubscriptionData, discountedPrice: e.target.value })}
                    />
                  </Grid>
                </Grid>
              </Paper>

              <Paper sx={{ p: 4, borderRadius: 3 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 3, color: "slate.800" }}>
                  Status & Visibility
                </Typography>
                <div className="space-y-4">
                  <FormControl component="fieldset" fullWidth>
                    <FormLabel component="legend" sx={{ fontSize: 13, fontWeight: 500, mb: 1 }}>Display on App</FormLabel>
                    <RadioGroup
                      row
                      value={addSubscriptionData.displayOnApp}
                      onChange={(e) => setAddSubscriptionData({ ...addSubscriptionData, displayOnApp: e.target.value === "true" })}
                    >
                      <FormControlLabel value={true} control={<Radio size="small" />} label="Show" />
                      <FormControlLabel value={false} control={<Radio size="small" />} label="Hide" />
                    </RadioGroup>
                  </FormControl>

                  <FormControl component="fieldset" fullWidth>
                    <FormLabel component="legend" sx={{ fontSize: 13, fontWeight: 500, mb: 1 }}>Service Status</FormLabel>
                    <RadioGroup
                      row
                      value={addSubscriptionData.isActive}
                      onChange={(e) => setAddSubscriptionData({ ...addSubscriptionData, isActive: e.target.value === "true" })}
                    >
                      <FormControlLabel value={true} control={<Radio size="small" />} label="Active" />
                      <FormControlLabel value={false} control={<Radio size="small" />} label="Inactive" />
                    </RadioGroup>
                  </FormControl>

                  <div className="flex gap-4 pt-2">
                    <FormControlLabel
                      control={
                        <Checkbox
                          size="small"
                          checked={addSubscriptionData.isTrial}
                          onChange={(e) => setAddSubscriptionData({ ...addSubscriptionData, isTrial: e.target.checked })}
                        />
                      }
                      label={<Typography variant="body2">Trial Period</Typography>}
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          size="small"
                          checked={addSubscriptionData.isDeleted}
                          onChange={(e) => setAddSubscriptionData({ ...addSubscriptionData, isDeleted: e.target.checked })}
                        />
                      }
                      label={<Typography variant="body2">Mark as Deleted</Typography>}
                    />
                  </div>
                </div>
              </Paper>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

const AddUserSubscription = ({ subscription }) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [users, setUsers] = useState(null);
  const [mobile, setMobile] = useState("");
  const [isSearching, setIsSearching] = useState(false);
  const [verifyUserTick, setVerifyUserTick] = useState(false);

  const [filterPayload, setFilterPayload] = useState({
    userId: null,
    subscriptionId: null,
    startDate: new Date().toISOString().split("T")[0],
  });

  const getUsers = (mobileNum) => {
    setIsSearching(true);
    UsersApi.GetUsersListByFilter({ mobile: mobileNum, page: 0, size: 5 })
      .then((res) => {
        setIsSearching(false);
        if (res.data.pages === 0) {
          toast(`No user found with ${mobileNum}`, { type: "error", position: "top-center" });
          setUsers(null);
          setVerifyUserTick(false);
        } else {
          setUsers(res.data.data);
          setVerifyUserTick(true);
        }
      })
      .catch((err) => {
        setIsSearching(false);
        toast(err?.response?.data?.message || "Search failed", { type: "error" });
      });
  };

  const createSubscription = () => {
    if (!filterPayload.userId || !filterPayload.subscriptionId) {
      toast("Please select a user and a subscription plan", { type: "warning" });
      return;
    }

    UsersSubscriptionsApi.AddUserSubscription(filterPayload)
      .then(() => {
        toast("Subscription assigned successfully", { type: "success" });
        setOpen(false);
        window.location.reload(); // Refresh to show new data
      })
      .catch((err) => {
        const msg = err?.response?.data?.message || "Failed to assign subscription";
        toast(msg, { type: "error" });
        if (err.response?.status === 401) {
          localStorage.clear();
          navigate("/");
        }
      });
  };

  const handleClose = () => {
    setOpen(false);
    setUsers(null);
    setMobile("");
    setVerifyUserTick(false);
  };

  return (
    <>
      <ActionButton
        variant="secondary"
        onClick={() => {
          setMobile("");
          setUsers(null);
          setFilterPayload({ ...filterPayload, userId: null, subscriptionId: null });
          setOpen(true);
        }}
        startIcon={
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        }
      >
        Assign to User
      </ActionButton>

      <Dialog 
        open={open} 
        onClose={handleClose} 
        maxWidth="md" 
        fullWidth
        PaperProps={{ sx: { borderRadius: 3 } }}
      >
        <DialogTitle sx={{ borderBottom: "1px solid", borderColor: "slate.100", pb: 2 }}>
          <Box className="flex items-center justify-between">
            <Typography variant="h6" sx={{ fontWeight: 700 }}>Assign Subscription</Typography>
            <IconButton onClick={handleClose} size="small"><CloseIcon /></IconButton>
          </Box>
        </DialogTitle>
        
        <DialogContent sx={{ p: 4 }}>
          <div className="space-y-6">
            <div className="bg-slate-50 p-6 rounded-2xl border border-dashed border-slate-200">
              <Typography variant="subtitle2" sx={{ mb: 2, color: "slate.600" }}>Step 1: Find User</Typography>
              <div className="flex gap-3">
                <TextField
                  fullWidth
                  placeholder="Enter user mobile number..."
                  value={mobile}
                  onChange={(e) => {
                    const val = e.target.value;
                    setMobile(val);
                    if (val.length === 10) getUsers(val);
                    else { setUsers(null); setVerifyUserTick(false); }
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        {isSearching ? <CircularProgress size={20} /> : <SearchIcon sx={{ color: "slate.400" }} />}
                      </InputAdornment>
                    ),
                    endAdornment: verifyUserTick && (
                      <InputAdornment position="end">
                        <div className="bg-emerald-100 text-emerald-600 p-1 rounded-full">
                          <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                          </svg>
                        </div>
                      </InputAdornment>
                    )
                  }}
                />
              </div>
            </div>

            {users && (
              <div className="animate-in fade-in slide-in-from-top-4 duration-300">
                <Typography variant="subtitle2" sx={{ mb: 2, color: "slate.600" }}>Step 2: Subscription Details</Typography>
                <TableCard>
                  <DataTable>
                    <thead>
                      <tr>
                        <Cell variant="head">User Details</Cell>
                        <Cell variant="head">Start Date</Cell>
                        <Cell variant="head">Select Plan</Cell>
                      </tr>
                    </thead>
                    <tbody>
                      {users.map((u) => (
                        <tr key={u.id}>
                          <Cell>
                            <Box>
                              <Typography variant="body2" sx={{ fontWeight: 600 }}>{u.name}</Typography>
                              <Typography variant="caption" sx={{ color: "slate.500" }}>{u.mobile}</Typography>
                            </Box>
                          </Cell>
                          <Cell sx={{ minWidth: 180 }}>
                            <TextField
                              type="date"
                              fullWidth
                              size="small"
                              value={filterPayload.startDate}
                              onChange={(e) => setFilterPayload({ ...filterPayload, startDate: e.target.value, userId: u.id })}
                            />
                          </Cell>
                          <Cell sx={{ minWidth: 200 }}>
                            <FormControl fullWidth size="small">
                              <Select
                                value={filterPayload.subscriptionId || ""}
                                onChange={(e) => setFilterPayload({ ...filterPayload, subscriptionId: e.target.value, userId: u.id })}
                                displayEmpty
                              >
                                <MenuItem value="" disabled>Choose Plan</MenuItem>
                                {subscription?.map((s) => (
                                  <MenuItem key={s.id} value={s.id}>{s.name} (₹{s.price})</MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </Cell>
                        </tr>
                      ))}
                    </tbody>
                  </DataTable>
                </TableCard>
              </div>
            )}
          </div>
        </DialogContent>

        <DialogActions sx={{ p: 4, pt: 0 }}>
          <Button onClick={handleClose} sx={{ color: "slate.400" }}>Cancel</Button>
          <ActionButton
            onClick={createSubscription}
            disabled={!filterPayload.userId || !filterPayload.subscriptionId}
          >
            Assign Subscription
          </ActionButton>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Subscriptions;
